  <ng-container *ngIf="!showDefaultImage">
    <img lib-amdocs-image-version (error)="showDefaultImage = true" class="avatar {{fontClass}}" [src]="fullPath"/>
  </ng-container>
  <ng-container *ngIf="showDefaultImage">
    <span class="avatar {{fontClass}}" >{{userShortName}}</span>
  </ng-container>

